import { memo } from 'react';

import { useIsStaffUser } from '@/hooks/useIsStaffUser';
import { useIsLimitedAccessUser } from '@/pages/shared/hooks/useIsLimitedAccessUser';
import { useIsOrganizationMember } from '@/pages/shared/hooks/useIsOrganizationMember';
import { isNullish } from '@/utils/booleans';

import { AIAgent } from './components/AIAgent';
import { CoPilotEmptyContent, CoPilotProps } from './components/CoPilot';
import { Recommendations } from './components/Recommendations';

const CoPilotInner = (props: CoPilotProps) => {
  const isLimitedAccessUser = useIsLimitedAccessUser();
  const isOrganizationMember = useIsOrganizationMember();

  return isLimitedAccessUser || !isOrganizationMember ? (
    <CoPilotEmptyContent {...props} />
  ) : (
    <CoPilotContent {...props} />
  );
};

const CoPilotContent = (props: CoPilotProps) => {
  const View = useGetCoPilotView();
  return !isNullish(View) ? <View {...props} /> : <CoPilotEmptyContent {...props} />;
};

const useGetCoPilotView = () => {
  const isStaff = useIsStaffUser();

  return isStaff ? AIAgent : Recommendations;
};

export const CoPilot = memo(CoPilotInner);
